import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import API from "../utils/API";
import "./billDigestModal.css";

const STATUS_ORDER = ['Chaptered', 'Vetoed', 'Signed by Governor'];

// Same colors as the dots in the Dashboard's Legislative Activity widget (dashboard.css
// .dot-chaptered / .dot-vetoed). No dedicated "Signed by Governor" row exists there, so that
// status borrows the widget's Awaiting Governor gold as the closest related color.
const STATUS_COLOR = {
    'Chaptered': '#2f7d4f',
    'Vetoed': '#b3453f',
    'Signed by Governor': '#c99a3e',
};

export default function BillDigestModal({ notificationId, userId, title, onClose }) {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        setLoading(true);
        setError(false);
        API.getNotificationDigestItems(notificationId, userId)
            .then(res => setItems(res.data))
            .catch(() => setError(true))
            .finally(() => setLoading(false));
    }, [notificationId, userId]);

    const byStatus = STATUS_ORDER
        .map(status => ({ status, bills: items.filter(i => i.end_status === status) }))
        .filter(group => group.bills.length > 0);

    return (
        <div className="modal fade show d-block bdm-overlay" tabIndex="-1" onClick={onClose}>
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable bdm-dialog" onClick={e => e.stopPropagation()}>
                <div className="modal-content">
                    <div className="modal-header bdm-header">
                        <h5 className="modal-title bdm-title">{title || "Tracked bills: status updates"}</h5>
                    </div>
                    <div className="modal-body bdm-body">
                        {loading ? (
                            <div className="bdm-loading">Loading…</div>
                        ) : error ? (
                            <div className="bdm-error">Unable to load digest details.</div>
                        ) : items.length === 0 ? (
                            <p className="text-muted bdm-empty">No bills found for this digest.</p>
                        ) : (
                            byStatus.map(group => (
                                <div key={group.status} className="bdm-status-group">
                                    <div className="bdm-status-heading">
                                        <span className="bdm-status-dot" style={{ backgroundColor: STATUS_COLOR[group.status] }} />
                                        {group.status}
                                    </div>
                                    <ul className="bdm-bill-list">
                                        {group.bills.map(bill => (
                                            <li key={bill.bill_id} className="bdm-bill-item">
                                                <Link to={`/legislation/bill/${bill.bill_id}`} className="bdm-bill-link" onClick={onClose}>
                                                    {bill.bill_type} {bill.bill_number}
                                                </Link>
                                                {' '}
                                                {bill.author && <span className="bdm-bill-author">({bill.author})</span>}
                                                {' '}
                                                {bill.title}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            ))
                        )}
                    </div>
                    <div className="modal-footer bdm-footer">
                        <button className="btn btn-sm btn-outline-secondary" onClick={onClose}>Close</button>
                    </div>
                </div>
            </div>
        </div>
    );
}
